import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import app from './modules/app'
import auth from './modules/auth'
import user from './modules/user'
import project from './modules/project'
import task from './modules/task'
import label from './modules/label'
import comment from './modules/comment'
import asset from './modules/asset'
import connection from './modules/connection'
import priority from './modules/priority'
import workflow from './modules/workflow'
import company from './modules/company'
import note from './modules/note'
import signup from './modules/signup'
import connectionRequest from './modules/connection-request'
import account from './modules/account'
import ability from './modules/ability'
import notification from './modules/notification'
import subscriptionType from './modules/subscription-type'
import milestone from './modules/milestone'

export default new Vuex.Store({
  modules: {
    app,
    auth,
    user,
    project,
    task,
    label,
    comment,
    asset,
    connection,
    priority,
    workflow,
    company,
    note,
    signup,
    connectionRequest,
    account,
    ability,
    notification,
    subscriptionType,
    milestone
  }
})
